import { AlertTriangle, Check, X } from 'lucide-react';
import type { Toast } from '../store/toast';
import { useTranslation } from 'react-i18next';

interface ToastContainerProps {
  toasts: Toast[];
  onDismiss: (id: string) => void;
}

const ToastContainer = ({ toasts, onDismiss }: ToastContainerProps) => {
  const { t } = useTranslation();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className="fixed top-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-[200] flex flex-col gap-2 pointer-events-none"
      aria-live="polite"
      aria-relevant="additions"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role={toast.type === 'error' ? 'alert' : 'status'}
          className="toast-item pointer-events-auto flex items-start gap-3 p-4 rounded-2xl bg-slate-900 text-white shadow-float"
        >
          {toast.type === 'success' ? (
            <Check size={18} className="shrink-0 mt-0.5 text-emerald-400" />
          ) : (
            <AlertTriangle size={18} className="shrink-0 mt-0.5 text-amber-400" />
          )}
          <p className="flex-1 text-sm font-medium leading-relaxed">{toast.message}</p>
          <button
            type="button"
            onClick={() => onDismiss(toast.id)}
            className="p-1 rounded-lg hover:bg-white/10 transition-colors text-slate-300 shrink-0"
            aria-label={t('Закрыть')}
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
